<template>
  <section class="market-card">
    <h2 v-if="title" class="market-card__title">{{ title }}</h2>
    <slot />
  </section>
</template>

<script>
  export default {
    name: 'MarketCard',

    props: {
      title: {
        type: String,
        required: false,
      },
    },
  }
</script>

<style scoped>
  .market-card {
    background: #fff;
    border: 1px solid var(--ui-border);
    border-radius: 12px;
    padding: 1.25rem;
    box-shadow: var(--ui-shadow-sm);
  }

  .market-card__title {
    font-size: 1.125rem;
    font-weight: 700;
    color: var(--ui-ink);
    margin-bottom: 0.75rem;
  }

  @media (min-width: 768px) {
    .market-card {
      padding: 1.5rem;
    }
  }
</style>
